import React from "react";
import { CgMenu, CgMenuGridR } from "react-icons/cg";
import styles from "./card_layout.module.scss";

const CardLayoutController = ({ setIsAlignRow, isAlignRow }) => {
  return (
    <div className={styles.grid_wrapper}>
      <CgMenu
        style={{ cursor: "pointer" }}
        onClick={() => setIsAlignRow(true)}
        className={`${isAlignRow ? styles.active : styles.inActive}`}
        size={25}
      />
      <CgMenuGridR
        style={{ cursor: "pointer" }}
        onClick={() => setIsAlignRow(false)}
        size={25}
        className={`${!isAlignRow ? styles.active : styles.inActive}`}
      />
    </div>
  );
};

export default CardLayoutController;
